module.exports = __webpack_public_path__ + "img/IMG_3419.626f2c41.jpg";